module.exports = __webpack_public_path__ + "images/tft-bottom-banner-bg-last-promo.webp";